/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Aero } from './Aero';
import type { ComponentConfigurationSet } from './ComponentConfigurationSet';
import type { DecelerationLimit } from './DecelerationLimit';
import type { Mass } from './Mass';
import type { WheelInput } from './WheelInput';
/**
 * Static requirement with both torque and acceleration.
 */
export type StaticRequirement = {
    item_type?: StaticRequirement.item_type;
    name?: string;
    description?: string;
    mass?: Mass;
    aero?: Aero;
    wheel?: WheelInput;
    deceleration_limit?: (DecelerationLimit | null);
    state_of_charge?: number;
    component_configurations?: ComponentConfigurationSet;
    ambient_temperature?: number;
    speed: number;
    altitude?: number;
    headwind?: number;
    gradient?: number;
    front_axle_split?: (number | null);
    steady_state?: boolean;
    steady_state_capability_curve?: boolean;
    total_tractive_torque: number;
    acceleration: number;
    aero_force: number;
    mass_force: number;
    rolling_resistance_force: number;
    total_force: number;
    total_tractive_power: number;
    voltage_oc: number;
};
export namespace StaticRequirement {
    export enum item_type {
        REQUIREMENT = 'requirement',
    }
}

